import React from 'react';
import KotlinIcon from '../assets/tech/kotlin.png';
import SqlIcon from '../assets/tech/sql.png';
import CIcon from '../assets/tech/c.png';
import CssIcon from '../assets/tech/css3.png';
import OracleIcon from '../assets/tech/oracle.png';
import PythonIcon from '../assets/tech/python.png';
import JavaIcon from '../assets/tech/java.png';
import HtmlIcon from '../assets/tech/html5.png';
import ReactIcon from '../assets/tech/react.png';
import TailwindIcon from '../assets/tech/tailwind.png';
import GitIcon from '../assets/tech/git.png';
import GitHubIcon from '../assets/tech/github.png';
import MongoDBIcon from '../assets/tech/mongodb.png';
import JSIcon from '../assets/tech/js.png';
import PandasIcon from '../assets/tech/pandas.svg';
import MaterializeIcon from '../assets/tech/materialize.svg';
import OpenCVIcon from '../assets/tech/opencv.png';
import PostgreIcon from '../assets/tech/postgre.png';
import ElementorIcon from '../assets/tech/elementor.png';
import AnacondaIcon from '../assets/tech/anaconda.svg';
import UnityIcon from '../assets/tech/unity.svg';
import SwiftIcon from '../assets/tech/swift.svg';
import SwiftUIIcon from '../assets/tech/swift.svg';
import NumpyIcon from '../assets/tech/numpy.svg';
import PolarsIcon from '../assets/tech/polars.svg';

const Tech = () => {
  // Definición de categorías y tecnologías
  const categories = [
    {
      name: "Front-End",
      items: [
        { name: "HTML", icon: HtmlIcon, learning: false },
        { name: "CSS", icon: CssIcon, learning: false },
        { name: "JavaScript", icon: JSIcon, learning: false },
        { name: "React", icon: ReactIcon, learning: false },
        { name: "Tailwind", icon: TailwindIcon, learning: false },
        { name: "Materialize", icon: MaterializeIcon, learning: false },
      ]
    },
    {
      name: "Back-End",
      items: [
        { name: "Java", icon: JavaIcon, learning: false },
        { name: "Python", icon: PythonIcon, learning: false },
        { name: "C#", icon: CIcon, learning: false },
        { name: "Node.js", icon: JSIcon, learning: false },
      ]
    },
    {
      name: "Desarrollo Móvil",
      items: [
        { name: "Kotlin", icon: KotlinIcon, learning: false },
        { name: "Swift", icon: SwiftIcon, learning: true },
        { name: "SwiftUI", icon: SwiftUIIcon, learning: true },
      ]
    },
    {
      name: "Bases de Datos",
      items: [
        { name: "Oracle", icon: OracleIcon, learning: false },
        { name: "SQL", icon: SqlIcon, learning: false },
        { name: "MongoDB", icon: MongoDBIcon, learning: false },
        { name: "PostgreSQL", icon: PostgreIcon, learning: false },
      ]
    },
    {
      name: "Herramientas & Frameworks",
      items: [
        { name: "Git", icon: GitIcon, learning: false },
        { name: "GitHub", icon: GitHubIcon, learning: false },
        { name: "Pandas", icon: PandasIcon, learning: false },
        { name: "OpenCV", icon: OpenCVIcon, learning: false },
        { name: "Anaconda", icon: AnacondaIcon, learning: false },
        { name: "Elementor", icon: ElementorIcon, learning: false },
        { name: "Polars", icon: PolarsIcon, learning: true },
        { name: "Numpy", icon: NumpyIcon, learning: false },
        { name: "Unity", icon: UnityIcon, learning: true },
      ]
    }
  ];

  return (
    <div className="p-4 sm:p-6 bg-transparent rounded-lg">
      <h2 className="text-2xl sm:text-3xl font-bold text-pastel-yellow mb-6 sm:mb-8 text-center">Tecnologías</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
        {categories.map((category, index) => (
          <CategorySection 
            key={index} 
            category={category.name} 
            items={category.items} 
          />
        ))}
      </div>
    </div>
  );
};

// Componente para la sección de categoría
const CategorySection = ({ category, items }) => {
  return (
    <div className="bg-neutral-800 rounded-xl shadow-xl p-4 sm:p-5 border border-neutral-700 mb-4">
      <h3 className="text-lg sm:text-xl font-bold text-pastel-yellow mb-3 sm:mb-4 pb-2 border-b border-neutral-700">
        {category}
      </h3>
      
      {/* Grid responsivo */}
      <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-2 sm:gap-3">
        {items.map((tech, idx) => (
          <TechItem 
            key={idx} 
            name={tech.name} 
            icon={tech.icon} 
            learning={tech.learning} 
          />
        ))}
      </div>
    </div>
  );
};

// Componente para cada item de tecnología (cuadradito)
const TechItem = ({ name, icon, learning }) => {
  return (
    <div className="flex flex-col items-center p-2 sm:p-3 bg-neutral-750 rounded-lg hover:bg-neutral-700 transition-all">
      {/* Contenedor cuadrado para el icono */}
      <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center mb-1 sm:mb-2 rounded-md bg-neutral-800 p-1">
        <img 
          src={icon} 
          alt={name} 
          className="w-full h-full object-contain" 
          style={{ objectFit: 'contain' }}
        />
      </div>
      
      {/* Nombre de la tecnología */}
      <span className="text-xs sm:text-sm font-medium text-white text-center mb-0.5 sm:mb-1">{name}</span>
      
      {/* Etiqueta "Aprendiendo" debajo del nombre */}
      {learning && (
        <span className="text-[10px] sm:text-xs font-bold text-amber-400 bg-amber-900 bg-opacity-50 px-1.5 py-0.5 sm:px-2 sm:py-1 rounded-full">
          Aprendiendo
        </span>
      )}
    </div>
  );
};

export default Tech;